import { flow, Runtime } from "fp";

import * as Data from "~/Data";
import * as Log from "~/Log";
import { Request } from "~/Request";
import { Time } from "~/Time";

import * as Entry from "../Entry";

export namespace Get {
  /** [API Documentation](http://equipmentshare.pages.internal.equipmentshare.com/equipmentshare-api/master/#get--time-tracking-entries) */
  export const request = (
    log: Log.Identity
  ): Data.Store.Request<Entry.Entry> => {
    const { interval } = Time.DateTime.toDayInterval(log);
    const start = Time.DateTime.toISOWithoutTime(interval.start);
    const stop = Time.DateTime.toISOWithoutTime(interval.stop);
    const endpoint = `/time-tracking/users/${log.driver.id}/entries?start_date=${start}&end_date=${stop}`;
    return flow(
      Request.fromConfig({ endpoint }),
      Request.Expect.status(200),
      Request.Expect.json(Runtime.array(Entry.Response.runtime())),
      Request.onSuccess(
        Data.Cache.fromList(
          flow(Entry.Response.decode, (entry) => [entry.id, entry])
        )
      )
    );
  };
}
